import { Suspense, type ComponentType } from "react";
import RouteLoading from "@/components/RouteLoading";

export default function LazyPage({ component: Component }: { component: ComponentType }) {
  return (
    <Suspense fallback={<RouteLoading />}>
      <Component />
    </Suspense>
  );
}
